module.exports = __webpack_public_path__ + "static/media/green_light.51becf71.png";